import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/translate/`;

const getTranslates = async () => {
    return await axios.get(API_URL);
};

const registerTranslate = async (formData) => {
    return await axios.post(API_URL, formData);
};

const updateTranslate = async (formData) => {
    return await axios.put(API_URL, formData);
};

const hideTranslate = async (translateId) => {
  console.log({translateId})
  return await axios.post(API_URL + 'hide', {translateId});
};

export default {
    getTranslates,
    registerTranslate,
    updateTranslate,
    hideTranslate
};
